import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/style.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    //dev help
    // <React.StrictMode>
    //     <App />
    // </React.StrictMode>

    <App />
);